import {
  loopbackDelete,
  LoopbackFilter,
  loopbackGet,
  loopbackPost,
  loopbackPut,
} from '..';
import { FaerbungReviewMeta, FaerbungReviewScore, PartialBy } from '../../redux/types';
import { constructQueryParams } from './apiUtil';

export const getFaerbungReviewMeta = (
  digitalSurveyId: number,
): Promise<FaerbungReviewMeta[]> => {
  const filter: LoopbackFilter = {
    where: {
      digitalSurveyId,
    },
  };
  const qp = constructQueryParams(filter);
  return loopbackGet(`FaerbungReviewMeta${qp}`);
};

export const addOrUpdateFaerbungMeta = (payload: PartialBy<FaerbungReviewMeta, 'id'>): Promise<FaerbungReviewMeta> => loopbackPost('FaerbungReviewMeta/addOrUpdateFaerbungMeta', payload);

export const deleteFaerbungMeta = (metaId: number): Promise<void> => loopbackDelete(`FaerbungReviewMeta/${metaId}`);

export const getFaerbungReviewScores = (
  digitalSurveyId: number,
  enrollmentId: number,
): Promise<FaerbungReviewScore[]> => {
  const filter: LoopbackFilter = {
    where: {
      digitalSurveyId,
      enrollmentId,
    },
  };
  const qp = constructQueryParams(filter);
  return loopbackGet(`FaerbungReviewScores${qp}`);
};

export const addOrUpdateFaerbungScores = (payload: PartialBy<FaerbungReviewScore, 'id'>[]): Promise<FaerbungReviewScore[]> => loopbackPost('FaerbungReviewScores/addOrUpdateFaerbungScore', payload);

export const initializeFaerbungMeta = (trialId: number): Promise<void> => loopbackGet(`FaerbungReviewMeta/initializeFaerbungMeta?trialId=${trialId}`);
